
export enum FORMAT_PRICE_MODE {
    PRICE_WITH_COMMA = "priceWithComma",
    PRICE_WITH_DOT = "priceWithDot",
}
const getStyle = (mode: FORMAT_PRICE_MODE) => {
    switch (mode) {
        case FORMAT_PRICE_MODE.PRICE_WITH_COMMA:
            return ",";
        case FORMAT_PRICE_MODE.PRICE_WITH_DOT:
            return ".";
        default:
            return ",";
    }
};
export function formatPrice(price: string, mode?: FORMAT_PRICE_MODE): string {
  let formattedPrice = Number(price).toFixed(2);
  let [integerPart, decimalPart] = formattedPrice.split('.');
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return integerPart + getStyle(mode) + decimalPart;
}
